export const version = 'v2.65.0-54-g71d1a6c2';
